import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const ReportDialog = ({ videoId, onClose }) => {
  const [f, setF] = useState({ kind: "abuse", reason: "", claimant_name: "", claimant_email: "", original_work_url: "", good_faith: false });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const send = () => api.post(`/ott/videos/${videoId}/report`, f)
    .then(() => { toast.success("Report sent to moderators"); onClose(); })
    .catch((e) => toast.error(e.response?.data?.detail || "Could not send report"));
  const input = "w-full border border-stone-200 rounded-xl px-3 py-2 text-sm";
  return (
    <div className="fixed inset-0 bg-black/50 grid place-items-center p-4" style={{ zIndex: "var(--z-modal)" }} onClick={onClose}>
      <div className="bg-white rounded-2xl p-4 w-full max-w-md space-y-2" onClick={(e) => e.stopPropagation()} data-testid="ott-report-dialog">
        <div className="font-black text-stone-900">Report this video</div>
        <select value={f.kind} onChange={set("kind")} className={input} data-testid="ott-report-kind">
          <option value="abuse">Harmful, abusive or misleading</option>
          <option value="copyright">Copyright — this is my work</option>
        </select>
        <textarea value={f.reason} onChange={set("reason")} placeholder="What's wrong?" className={input} rows={3} data-testid="ott-report-reason" />
        {f.kind === "copyright" && <>
          <input value={f.claimant_name} onChange={set("claimant_name")} placeholder="Your full name" className={input} data-testid="ott-report-name" />
          <input value={f.claimant_email} onChange={set("claimant_email")} placeholder="Your email" className={input} data-testid="ott-report-email" />
          <input value={f.original_work_url} onChange={set("original_work_url")} placeholder="Link to your original work" className={input} data-testid="ott-report-work" />
          <label className="text-xs text-stone-600 flex gap-2"><input type="checkbox" checked={f.good_faith} onChange={set("good_faith")} data-testid="ott-report-goodfaith" /> I believe in good faith this use is not authorised, and the information is accurate.</label>
        </>}
        <div className="flex justify-end gap-2 pt-1">
          <button onClick={onClose} className="text-sm font-bold text-stone-500 px-3">Cancel</button>
          <button onClick={send} className="text-sm font-bold bg-red-600 text-white rounded-full px-4 py-2" data-testid="ott-report-submit">Send report</button>
        </div>
      </div>
    </div>
  );
};
